import React from 'react'
import Hero from '../../component/home/Hero'

const Getquote = () => {
  return (
    <>
    <Hero/>
    </>
  )
}

export default Getquote